import { render, staticRenderFns } from "./UserAuthLayout.vue?vue&type=template&id=eff43f3c&"
import script from "./UserAuthLayout.vue?vue&type=script&lang=ts&"
export * from "./UserAuthLayout.vue?vue&type=script&lang=ts&"
import style0 from "./UserAuthLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports